import { useState, useEffect, useCallback } from 'react';
import { Table, Input, message } from 'antd';
import { getData } from '../api';

const COLUMNS = [
  { title: 'BU', dataIndex: 'BU', key: 'BU', width: 70, fixed: 'left', sorter: true },
  { title: '产品线', dataIndex: 'AuthorizedProduct', key: 'AuthorizedProduct', width: 180, ellipsis: true },
  { title: '经销商名称', dataIndex: 'DistributorName', key: 'DistributorName', width: 200, ellipsis: true },
  { title: '经销商代码', dataIndex: 'DistributorCode', key: 'DistributorCode', width: 130 },
  { title: '合作状态', dataIndex: 'CooperationStatus', key: 'CooperationStatus', width: 80 },
  { title: '经销商类型', dataIndex: 'DistributorType', key: 'DistributorType', width: 100 },
  { title: '上级经销商', dataIndex: 'ParentDistributorName', key: 'ParentDistributorName', width: 160, ellipsis: true },
  { title: 'BPTotal', dataIndex: 'BPTotal', key: 'BPTotal', width: 120, align: 'right',
    render: (v) => v != null ? v.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00' },
  { title: '1月', dataIndex: 'Jan', key: 'Jan', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '2月', dataIndex: 'Feb', key: 'Feb', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '3月', dataIndex: 'Mar', key: 'Mar', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '4月', dataIndex: 'Apr', key: 'Apr', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '5月', dataIndex: 'May', key: 'May', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '6月', dataIndex: 'Jun', key: 'Jun', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '7月', dataIndex: 'Jul', key: 'Jul', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '8月', dataIndex: 'Aug', key: 'Aug', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '9月', dataIndex: 'Sep', key: 'Sep', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '10月', dataIndex: 'Oct', key: 'Oct', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '11月', dataIndex: 'Nov', key: 'Nov', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '12月', dataIndex: 'Dec', key: 'Dec', width: 100, align: 'right',
    render: (v) => v != null ? v.toLocaleString() : '0' },
  { title: '状态', dataIndex: 'Status', key: 'Status', width: 70 },
];

export default function DataTable({ filters }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 50, total: 0 });
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState({ field: 'id', order: 'ascend' });

  const fetchData = useCallback(async (page, pageSize, sortField, sortOrder) => {
    setLoading(true);
    try {
      const params = {
        ...filters,
        page,
        page_size: pageSize,
        sort_field: sortField || 'id',
        sort_order: sortOrder === 'descend' ? 'desc' : 'asc',
      };
      if (search) params.search = search;
      const res = await getData(params);
      setData(res.data.data);
      setPagination(prev => ({ ...prev, current: page, pageSize, total: res.data.total }));
    } catch (e) {
      message.error('加载数据失败');
    }
    setLoading(false);
  }, [filters, search]);

  useEffect(() => {
    fetchData(1, pagination.pageSize, sort.field, sort.order);
  }, [filters]);

  const handleTableChange = (pag, _filters, sorter) => {
    const field = sorter.field || sort.field;
    const order = sorter.order || 'ascend';
    setSort({ field, order });
    fetchData(pag.current, pag.pageSize, field, order);
  };

  const handleSearch = (value) => {
    setSearch(value);
    fetchData(1, pagination.pageSize, sort.field, sort.order);
  };

  return (
    <div className="table-card">
      <div className="toolbar">
        <div className="left">
          明细数据
          <span style={{ fontSize: 12, color: '#8c8c8c', fontWeight: 'normal', marginLeft: 8 }}>
            共 {pagination.total.toLocaleString()} 条
          </span>
        </div>
        <Input.Search
          placeholder="搜索经销商/产品线/代码"
          allowClear
          style={{ width: 300 }}
          onSearch={handleSearch}
        />
      </div>
      <Table
        columns={COLUMNS}
        dataSource={data}
        rowKey="id"
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
        scroll={{ x: 2400 }}
        size="middle"
      />
    </div>
  );
}
